module.exports = __webpack_public_path__ + "static/color element-34-59f043e7fd863875df329868e91126d3.png";